export enum CopyOption {
    Users = "Users",
    Workspace = "Workspace",
    NewWorkspace = "New Workspace",
    PersonalWorkspace = "Personal Workspace"
};